import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'hooks/redux';
import { Box, IconButton } from '@mui/material';
import { TooltipMapIcon } from 'components/UI/TooltipMapIcon';
import { getText } from 'services/languageService';
import { MapElementIcon } from 'components/UI/MapElementIcon';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { MetadataModal } from './MetadataModal';

export const MetadataElement: React.FC = () => {
  const [open, setOpen] = useState(false);
  const { currenMetaFileUrl } = useAppSelector((state) => state.layers);

  const toggleOpen = () => {
    setOpen(!open);
  };

  return currenMetaFileUrl ? (
    <Box sx={{ position: 'relative' }}>
      <TooltipMapIcon title={getText('METADATA')}>
        <MapElementIcon>
          <IconButton onClick={toggleOpen}>
            <InfoOutlinedIcon />
          </IconButton>
        </MapElementIcon>
      </TooltipMapIcon>
      <Box
        sx={{
          position: 'absolute',
          right: 50,
          bottom: 10,
          backgroundColor: 'white',
          zIndex: 1000,

          svg: {
            fill: 'inherit',
            fontSize: '1em',
          },
        }}
      >
        <MetadataModal open={open} handleClose={toggleOpen} />
      </Box>
    </Box>
  ) : null;
};
